
export default function Industries() {
  const industries = [
    {
      title: "Infrastructure & Government Projects",
      description: "Supporting major infrastructure developments, highways, bridges, and government construction initiatives.",
      icon: "ri-government-line",
      image: "https://readdy.ai/api/search-image?query=Large%20infrastructure%20construction%20project%20with%20government%20buildings%2C%20highways%20and%20bridges%20under%20construction%2C%20heavy%20machinery%20and%20professional%20construction%20teams%2C%20modern%20civil%20engineering%20work%20with%20quality%20materials%20and%20systematic%20approach&width=400&height=300&seq=industry1&orientation=landscape"
    },
    {
      title: "Residential & Commercial Real Estate",
      description: "Providing comprehensive chemical solutions for residential complexes and commercial building projects.",
      icon: "ri-building-line",
      image: "https://readdy.ai/api/search-image?query=Modern%20residential%20and%20commercial%20building%20construction%2C%20high-rise%20apartments%20and%20office%20complexes%20under%20development%2C%20construction%20workers%20and%20quality%20building%20materials%2C%20professional%20real%20estate%20development%20with%20advanced%20construction%20techniques&width=400&height=300&seq=industry2&orientation=landscape"
    },
    {
      title: "Industrial Plants & Factories",
      description: "Specialized solutions for industrial facilities requiring high-performance construction chemicals.",
      icon: "ri-factory-line",
      image: "https://readdy.ai/api/search-image?query=Industrial%20plant%20and%20factory%20construction%20with%20specialized%20chemical%20applications%2C%20manufacturing%20facility%20development%2C%20industrial%20construction%20workers%20using%20advanced%20materials%2C%20heavy%20industrial%20infrastructure%20with%20professional%20safety%20standards&width=400&height=300&seq=industry3&orientation=landscape"
    },
    {
      title: "Public Works (Bridges, Dams, Tunnels)",
      description: "Critical infrastructure projects demanding the highest quality and durability standards.",
      icon: "ri-bridge-line",
      image: "https://readdy.ai/api/search-image?query=Major%20public%20works%20construction%20including%20bridges%2C%20dams%20and%20tunnels%2C%20massive%20concrete%20structures%20and%20engineering%20projects%2C%20specialized%20construction%20equipment%20and%20professional%20engineering%20teams%2C%20critical%20infrastructure%20development%20work&width=400&height=300&seq=industry4&orientation=landscape"
    },
    {
      title: "RMC Plants & Aggregators",
      description: "Supplying admixtures and chemical solutions to ready-mix concrete plants across the region.",
      icon: "ri-truck-line",
      image: "https://readdy.ai/api/search-image?query=Ready-mix%20concrete%20plant%20operations%20with%20concrete%20mixing%20trucks%2C%20industrial%20RMC%20facility%20with%20conveyor%20systems%20and%20storage%20silos%2C%20concrete%20production%20equipment%20and%20quality%20control%20processes%2C%20modern%20batching%20plant%20operations&width=400&height=300&seq=industry5&orientation=landscape"
    },
    {
      title: "Specialty Applicator Firms",
      description: "Supporting specialized contractors with technical expertise and premium chemical solutions.",
      icon: "ri-tools-fill",
      image: "https://readdy.ai/api/search-image?query=Specialty%20construction%20contractors%20applying%20advanced%20chemical%20solutions%2C%20professional%20applicator%20teams%20using%20specialized%20equipment%2C%20technical%20construction%20work%20with%20precision%20application%20methods%2C%20expert%20contractors%20in%20protective%20gear&width=400&height=300&seq=industry6&orientation=landscape"
    }
  ];

  const successStories = [
    {
      title: "XYZ Metro Project - Delhi",
      description: "Supplied complete waterproofing solution for metro tunnel construction, ensuring long-term durability against groundwater.",
      type: "Infrastructure"
    },
    {
      title: "ABC Bridge Project - Rajasthan",
      description: "Delivered admixtures and grouting systems for critical bridge construction in challenging desert conditions.",
      type: "Public Works"
    },
    {
      title: "Clean Room Facility - Pune",
      description: "Provided specialized epoxy flooring solutions for pharmaceutical manufacturing clean room requirements.",
      type: "Industrial"
    },
    {
      title: "Leading RMC Plants Partnership",
      description: "Partnered with major RMC plants for continuous supply of concrete admixtures across multiple states.",
      type: "RMC Plants"
    }
  ];

  return (
    <section id="industries" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Industries &amp; Clients We Serve
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              From government infrastructure to specialized industrial applications, we serve diverse sectors 
              with tailored construction chemical solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {/* Infrastructure & Government Projects */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Large%20infrastructure%20construction%20project%20with%20government%20buildings%2C%20highways%20and%20bridges%20under%20construction%2C%20heavy%20machinery%20and%20professional%20construction%20teams%2C%20modern%20civil%20engineering%20work%20with%20quality%20materials%20and%20systematic%20approach&width=400&height=300&seq=industry1&orientation=landscape"
                  alt="Infrastructure &amp; Government Projects"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-government-line text-xl" style={{ color: '#7E887E' }}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Infrastructure &amp; Government Projects</h3>
                <p className="text-gray-600 leading-relaxed">
                  Supporting major infrastructure developments, highways, bridges, and government construction initiatives.
                </p>
              </div>
            </div>

            {/* Residential & Commercial Real Estate */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20residential%20and%20commercial%20building%20construction%2C%20high-rise%20apartments%20and%20office%20complexes%20under%20development%2C%20construction%20workers%20and%20quality%20building%20materials%2C%20professional%20real%20estate%20development%20with%20advanced%20construction%20techniques&width=400&height=300&seq=industry2&orientation=landscape"
                  alt="Residential &amp; Commercial Real Estate"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-building-line text-xl" style={{ color: '#7E887E' }}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Residential &amp; Commercial Real Estate</h3>
                <p className="text-gray-600 leading-relaxed">
                  Providing comprehensive chemical solutions for residential complexes and commercial building projects.
                </p>
              </div>
            </div>

            {/* Industrial Plants & Factories */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Industrial%20plant%20and%20factory%20construction%20with%20specialized%20chemical%20applications%2C%20manufacturing%20facility%20development%2C%20industrial%20construction%20workers%20using%20advanced%20materials%2C%20heavy%20industrial%20infrastructure%20with%20professional%20safety%20standards&width=400&height=300&seq=industry3&orientation=landscape"
                  alt="Industrial Plants &amp; Factories"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-factory-line text-xl" style={{ color: '#7E887E' }}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Industrial Plants &amp; Factories</h3>
                <p className="text-gray-600 leading-relaxed">
                  Specialized solutions for industrial facilities requiring high-performance construction chemicals.
                </p>
              </div>
            </div>

            {/* Public Works */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Major%20public%20works%20construction%20including%20bridges%2C%20dams%20and%20tunnels%2C%20massive%20concrete%20structures%20and%20engineering%20projects%2C%20specialized%20construction%20equipment%20and%20professional%20engineering%20teams%2C%20critical%20infrastructure%20development%20work&width=400&height=300&seq=industry4&orientation=landscape"
                  alt="Public Works (Bridges, Dams, Tunnels)"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-bridge-line text-xl" style={{ color: '#7E887E' }}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Public Works (Bridges, Dams, Tunnels)</h3>
                <p className="text-gray-600 leading-relaxed">
                  Critical infrastructure projects demanding the highest quality and durability standards.
                </p>
              </div>
            </div>

            {/* RMC Plants & Aggregators */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Ready-mix%20concrete%20plant%20operations%20with%20concrete%20mixing%20trucks%2C%20industrial%20RMC%20facility%20with%20conveyor%20systems%20and%20storage%20silos%2C%20concrete%20production%20equipment%20and%20quality%20control%20processes%2C%20modern%20batching%20plant%20operations&width=400&height=300&seq=industry5&orientation=landscape"
                  alt="RMC Plants &amp; Aggregators"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-truck-line text-xl" style={{ color: '#7E887E' }}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">RMC Plants &amp; Aggregators</h3>
                <p className="text-gray-600 leading-relaxed">
                  Supplying admixtures and chemical solutions to ready-mix concrete plants across the region.
                </p>
              </div>
            </div>

            {/* Specialty Applicator Firms */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Specialty%20construction%20contractors%20applying%20advanced%20chemical%20solutions%2C%20professional%20applicator%20teams%20using%20specialized%20equipment%2C%20technical%20construction%20work%20with%20precision%20application%20methods%2C%20expert%20contractors%20in%20protective%20gear&width=400&height=300&seq=industry6&orientation=landscape"
                  alt="Specialty Applicator Firms"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-tools-fill text-xl" style={{ color: '#7E887E' }}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Specialty Applicator Firms</h3>
                <p className="text-gray-600 leading-relaxed">
                  Supporting specialized contractors with technical expertise and premium chemical solutions.
                </p>
              </div>
            </div>
          </div>

          {/* Success Stories */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Success Stories &amp; Projects</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="border-l-4 pl-6" style={{ borderColor: '#7E887E' }}>
                <div className="flex items-center mb-2">
                  <span 
                    className="text-xs font-semibold px-2 py-1 rounded-full mr-3 text-white"
                    style={{ backgroundColor: '#7E887E' }}
                  >
                    Infrastructure
                  </span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">XYZ Metro Project - Delhi</h4>
                <p className="text-gray-600 leading-relaxed">
                  Supplied complete waterproofing solution for metro tunnel construction, ensuring long-term durability against groundwater.
                </p>
              </div>

              <div className="border-l-4 pl-6" style={{ borderColor: '#7E887E' }}>
                <div className="flex items-center mb-2">
                  <span 
                    className="text-xs font-semibold px-2 py-1 rounded-full mr-3 text-white"
                    style={{ backgroundColor: '#7E887E' }}
                  >
                    Public Works
                  </span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">ABC Bridge Project - Rajasthan</h4>
                <p className="text-gray-600 leading-relaxed">
                  Delivered admixtures and grouting systems for critical bridge construction in challenging desert conditions.
                </p>
              </div>

              <div className="border-l-4 pl-6" style={{ borderColor: '#7E887E' }}>
                <div className="flex items-center mb-2">
                  <span 
                    className="text-xs font-semibold px-2 py-1 rounded-full mr-3 text-white"
                    style={{ backgroundColor: '#7E887E' }}
                  >
                    Industrial
                  </span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">Clean Room Facility - Pune</h4>
                <p className="text-gray-600 leading-relaxed">
                  Provided specialized epoxy flooring solutions for pharmaceutical manufacturing clean room requirements.
                </p>
              </div>

              <div className="border-l-4 pl-6" style={{ borderColor: '#7E887E' }}>
                <div className="flex items-center mb-2">
                  <span 
                    className="text-xs font-semibold px-2 py-1 rounded-full mr-3 text-white"
                    style={{ backgroundColor: '#7E887E' }}
                  >
                    RMC Plants
                  </span>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">Leading RMC Plants Partnership</h4>
                <p className="text-gray-600 leading-relaxed">
                  Partnered with major RMC plants for continuous supply of concrete admixtures across multiple states.
                </p>
              </div>
            </div>
          </div>

          {/* Vision Section */}
          <div 
            className="mt-16 rounded-2xl p-8 md:p-12 text-center text-white"
            style={{ background: `linear-gradient(to right, #7E887E, #6B756B)` }}
          >
            <h3 className="text-3xl font-bold mb-6">Our Vision</h3>
            <p className="text-xl mb-6 opacity-90 leading-relaxed max-w-4xl mx-auto">
              To be India's <strong>most trusted and technically empowered</strong> construction chemical distributor.
            </p>
            <p className="text-lg opacity-80 leading-relaxed max-w-5xl mx-auto">
              We aim to set new benchmarks in service, reliability, and technical excellence — so that every structure built 
              with our support stands strong, sustainable, and future-ready.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
